import { filterData } from '../../../utils';
import * as types from './types';

const initialState = {
  loading: false,
  success: false,
  error: false,
  fetched: false,
  data: [],
  errorUpload: false,
  errorDelete: false,
  errorSave: false,
  isUploading: false,
  coverPhoto: null,
  listPhone: []
};

function micrositeReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DATA_MICROSITE:
      return {
        ...state,
        loading: true
      };
    case types.GET_DATA_MICROSITE_COMPLETED:
      return {
        ...state,
        loading: false,
        fetched: true,
        data: filterData(action.payload)
      };
    case types.GET_DATA_MICROSITE_FAILED:
      return {
        ...state,
        loading: false,
        error: true
      };
    case types.PUT_DATA_MICROSITE:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
        errorUpload: false,
        errorDelete: false,
        errorSave: false,
        isUploading: false,
        coverPhoto: null
      };
    case types.PUT_DATA_MICROSITE_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true,
        error: false
      };
    case types.PUT_DATA_MICROSITE_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        errorSave: true
      };
    case types.POST_DATA_MICROSITE:
      return {
        ...state,
        success: false,
        error: false,
        errorUpload: false,
        errorDelete: false,
        errorSave: false,
        isUploading: true,
        coverPhoto: null
      };
    case types.POST_DATA_MICROSITE_COMPLETED:
      return {
        ...state,
        isUploading: false,
        errorUpload: false,
        coverPhoto: action.payload
      };
    case types.POST_DATA_MICROSITE_FAILED:
      return {
        ...state,
        isUploading: false,
        errorUpload: true,
        coverPhoto: null
      };
    case types.DELETE_IMAGE_COVER_PHOTO:
      return {
        ...state,
        loading: true,
        errorUpload: false,
        success: false,
        errorDelete: false,
        coverPhoto: null,
        errorSave: false
      };
    case types.DELETE_IMAGE_COVER_PHOTO_COMPLETED:
      return {
        ...state,
        loading: false,
        errorUpload: false,
        errorDelete: false,
        coverPhoto: null
      };
    case types.DELETE_IMAGE_COVER_PHOTO_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        errorDelete: true,
        coverPhoto: null
      };
    case types.GET_LIST_PHONE_MICROSITE:
      return {
        ...state,
        loading: true,
        fetched: false
      };
    case types.GET_LIST_PHONE_MICROSITE_COMPLETED:
      return {
        ...state,
        loading: false,
        fetched: true,
        listPhone: action.payload
      };
    case types.GET_LIST_PHONE_MICROSITE_FAILED:
      return {
        ...state,
        loading: false,
        fetched: false,
        error: true,
        listPhone: []
      };
    default:
      return state;
  }
}

export default micrositeReducer;
